import { CameraDeviceInfo, useMediaDevice, useMeeting } from "@videosdk.live/react-sdk";
import { useState } from "react";
import {
  Button, Space, Tooltip, Popover, Typography
} from "antd";
import {
  VideoCameraOutlined, VideoCameraFilled, DownOutlined
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import useMediaStream from "../../../hooks/useMediaStream";
import useVideoStore from "../../../hooks/useVideoStore";

const { Title } = Typography;

const WebcamButton = () => {
  const { t } = useTranslation();
  const {
    selectedWebcam,
    setSelectedWebcam,
    isCameraPermissionAllowed,
  } = useVideoStore();
  const { getCameras } = useMediaDevice();
  const mMeeting = useMeeting();
  const [webcams, setWebcams] = useState<CameraDeviceInfo[]>([]);
  const { getVideoTrack } = useMediaStream();

  const localWebcamOn = mMeeting?.localWebcamOn;
  const changeWebcam = mMeeting?.changeWebcam;

  const getWebcams = async () => {
    const wCams = await getCameras();
    if (wCams && wCams?.length) setWebcams(wCams);
  };

  return (
    <Space.Compact>
      <Tooltip title={!isCameraPermissionAllowed ? t("video.accessDenied") : t("video.toggleCam")}>
        <Button
          type={localWebcamOn ? "primary" : "default"}
          size="large"
          icon={localWebcamOn ? <VideoCameraFilled /> : <VideoCameraOutlined/>}
          onClick={async () => {
            let track: MediaStream | undefined;
            if (!localWebcamOn) {
              track = await getVideoTrack({
                webcamId: selectedWebcam.id as string
              });
            }

            mMeeting.toggleWebcam(track);
          }}
          disabled={!isCameraPermissionAllowed}
        />
      </Tooltip>
      <Popover
        content={(
          <Space direction="vertical" size={0}>
            <Title level={5}>{t("video.webcam")}</Title>
            {webcams.map(({ deviceId, label }, index) => (
              <Button
                key={`mics_${deviceId}`}
                type={deviceId === selectedWebcam.id ? "primary" : "text"}
                onClick={() => {
                  setSelectedWebcam({ id: deviceId });
                  changeWebcam(deviceId);
                }}
                block
              >
                {label || `Webcams ${index + 1}`}
              </Button>
            ))}
          </Space>
        )}
        trigger="click"
        placement="topLeft"
      >
        <Tooltip title={!isCameraPermissionAllowed ? t("video.accessDenied") : t("video.changeCam")}>
          <Button
            type={localWebcamOn ? "primary" : "default"}
            size="large"
            icon={<DownOutlined />}
            disabled={!isCameraPermissionAllowed}
            onClick={() => getWebcams()}
          />
        </Tooltip>
      </Popover>
    </Space.Compact>
  );
};

export default WebcamButton;
